<div class="main">
    <div class="container">
        <div class="page_main">
            <div class="user_list">
                <app-user-list (selectedUser)="selectUser($event)"></app-user-list>
              </div>
              <div class="chat_window">
                <app-product-chat-window></app-product-chat-window>
              </div>
        </div>
    </div>
</div>


<div class="modal fade" id="exampleModalToggleChat" aria-hidden="true" aria-labelledby="exampleModalToggleLabel"
    tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content closeChat_modal">
            <div class="modal-header">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <p class="title">Are you sure you would like to close this chat?</p>
                <p class="text"><img src="/assets/icons/modals/info_icon.svg" alt=""> By closing this chat, your message
                    history will not be cleared. You can reopen the chat by sending
                    the user a message on their profile or from the dashboard wherever applicable.</p>
            </div>
            <div class="modal-footer">
                <button class="btn_cancel">Cancel</button>
                <button class="btn_close">Close Chat</button>
            </div>
        </div>
    </div>
</div>
<!-- <button class="btn btn-primary" data-bs-target="#exampleModalToggleChat" data-bs-toggle="modal">Close Chat</button> -->